import { createSelector } from '@ngrx/store';
import { ChangeCredentialsDialogState } from './change-credentials-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Change-Credentials-Dialog.
 */
export class ChangeCredentialsDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): ChangeCredentialsDialogState => state.changeCredentialsDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

  /**
   * Selector für den Dialog-Titel.
   */
  public static readonly title = createSelector(
    this._slice,
    (state) => state.title,
  );

  /**
   * Selector für den Prompt-Text.
   */
  public static readonly prompt = createSelector(
    this._slice,
    (state) => state.prompt,
  );

  /**
   * Selector für die URL.
   */
  public static readonly url = createSelector(
    this._slice,
    (state) => state.url,
  );
}
